import { c as _c } from "react/compiler-runtime";
import { SingleFilterChip } from "@components/common/faro-table/faro-table-filter/single-filter-chip";
import { useProjectMarkupsFilterLists } from "@pages/project-details/project-markups/project-markups-filters/project-markups-filter-list";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { TableType } from "@utils/track-event/track-event-list";

/** Show filters and apply them for project markup Attachment */
export function ProjectMarkupsAttachmentFilter() {
  const $ = _c(4);
  const allFilters = useProjectMarkupsFilterLists();
  let t0;
  if ($[0] !== allFilters.Attachments) {
    t0 = allFilters.Attachments ?? {};
    $[0] = allFilters.Attachments;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SingleFilterChip filteredColumn={ProjectMarkupsTableHeaders.attachments} label="Has linked attachments" item={t0} tableType={TableType.projectMarkups} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}